// extracted by mini-css-extract-plugin
export default {"label":"O5Mcj","content":"SXC_T","dialogSection":"ajRIt","assetMetadata":"FWZja","title":"ZWilN"};